<template>
  <b-container fluid class="p-0 fullContent">
    <b-row v-if="loading">
      <b-col class="px-md-3 px-lg-6 py-5 shadow bg-white" offset-xl="2" xl="8">
        <LoadingSpinner :message="`Loading Notification`" />
      </b-col>
    </b-row>
    <NotificationForm
      v-if="!loading && (!notification.statusId || draft)"
    />
    <Summary
      v-if="!loading && (pendingCertification || active || closed || scheduled)"
      :fullscreen="true"
    />
  </b-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import LoadingSpinner from '@/components/common/LoadingSpinner.vue';
import NotificationForm from '@/components/notification/NotificationForm.vue';
import Summary from '@/components/notification/summary/Summary.vue';

export default {
  name: 'Notification',
  components: {
    LoadingSpinner,
    NotificationForm,
    Summary,
  },
  data() {
    return {
      loading: true,
    };
  },
  computed: {
    ...mapState('Notification', {
      notification: state => state.notification,
    }),
    ...mapGetters('Notification', ['draft', 'pendingCertification', 'active', 'closed', 'scheduled']),
  },
  created() {
    const id = this.$route.params.id;
    if (id && !isNaN(id)) {
      this.$store.dispatch('Notification/getNotification', id)
        .then(async () => {
          await this.$store.dispatch('Activity/fetchActivities');
          await this.$store.dispatch('ActivityDetails/fetch');
          await this.$store.dispatch('Notification/fetchCertifications');
          this.loading = false;
        });
    } else {
      this.$store.dispatch('Notification/unload');
      this.$store.dispatch('Activity/unload');
      this.loading = false;
    }
  },
};
</script>
